// extracted by mini-css-extract-plugin
export default {"body":"Layout_body__3J5Hj","main":"Layout_main__YvU+T","footer":"Layout_footer__ZUb33"};